/* eslint-disable css-modules/no-unused-class, no-extra-boolean-cast */
import { useState } from 'react';
import classNames from 'classnames';
import { translate } from 'translations';
import { Tooltip, Icon } from 'learning-panel-components';
import styles from './mapLegend.module.scss';

const MapLegend = () => {
    const [isExpanded, setIsExpanded] = useState<boolean>(false);
    const [animate, setAnimate] = useState(false);

    const onUnExpand = () => {
        setIsExpanded(false);
        setTimeout(() => {
            setAnimate(false);
        }, 500);
    };
    const onExpand = () => {
        setIsExpanded(true);
        setTimeout(() => {
            setAnimate(false);
        }, 500);
    };

    const items = [
        {
            name: 'Unit',
            values: [
                { name: 'Course', icon: `${process.env.PUBLIC_URL}/images/courseTopIcon.svg` },
                { name: 'Lesson', icon: `${process.env.PUBLIC_URL}/images/lessonTopIcon.svg` },
                { name: 'Challenge', icon: `${process.env.PUBLIC_URL}/images/challengeTopIcon.svg` },
                { name: 'AssessmentContent', icon: `${process.env.PUBLIC_URL}/images/assessmentTopIcon.svg` },
                { name: 'node', icon: `${process.env.PUBLIC_URL}/images/mixTop.svg` }
            ]
        },
        {
            name: 'Type',
            values: [
                { name: 'mandatory', icon: `${process.env.PUBLIC_URL}/images/mandatory.svg` },
                { name: 'optional', icon: `${process.env.PUBLIC_URL}/images/optional.svg` }
            ]
        }
    ];

    const handleItem = (item: any) => {
        return (
            <div key={item.name} className={styles['item-wrapper']}>
                <div className={styles['title-wrapper']}>
                    <Icon name={'key'} />
                    <div className={styles['item-name']}>{item.name}</div>
                </div>
                <div className={styles['values-wrapper']}>
                    {item.values.map((value: any) => (
                        <div key={value.name} className={styles['value-wrapper']}>
                            <img src={value.icon} className={styles.icon} alt="icon" />
                            <div>{translate(value.name)}</div>
                        </div>
                    ))}
                </div>
            </div>
        );
    };

    return isExpanded ? (
        <div className={classNames(styles['map-legend-wrapper'], { [styles.animate]: animate })}>
            <div key="left-side-panel" className={styles['expand-button']} onClick={onUnExpand}>
                <Tooltip
                    key="left-side-panel-tooltip"
                    placement="right"
                    title={<div>{translate('CollapsePanel')}</div>}
                    enterDelay
                >
                    <div>
                        <Icon name="unExpand" key="unExpand" />
                    </div>
                </Tooltip>
            </div>
            <div className={styles['map-legend']}>
                {items.length >= 1 && handleItem(items[0])}
                <hr className={styles['map-divider']} />
                {items.length >= 2 && handleItem(items[1])}
            </div>
        </div>
    ) : (
        <div className={styles['map-legend-closed-wrapper']}>
            <div key="left-side-panel-un-expand" className={styles['un-expand-button']} onClick={onExpand}>
                <Icon name="expand" key="expand" />
            </div>
            <div className={styles['map-legend-closed']}>
                <Icon name={'key'} />
            </div>
        </div>
    );
};

export default MapLegend;
